import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { WebPopService, State } from '../services';

export const webExternal = (webPop: WebPopService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (!state.system?.webExternal)
        return of([state, currentState] as [Partial<State>, State]);

      const { url, additionalVars } = state.system.webExternal;
      webPop.external(url, additionalVars);
      return of([
        {
          ...state,
          ...{
            system: {
              ...state.system,
              webExternal: undefined,
            },
          },
        },
        currentState,
      ] as [Partial<State>, State]);
    })
  );
